import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@finitless/shared/lib";
import { toast } from "sonner";

/**
 * Hook to toggle business enabled status
 * @returns {Object} Mutation result
 */
export const useBusinessToggle = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ businessId, enabled }) => {
      const response = await apiClient.post(`/business/${businessId}`, {
        enabled,
      });
      return response;
    },
    onSuccess: (data, variables) => {
      const { businessId, enabled } = variables;

      // Update all businesses queries in the cache
      queryClient.setQueriesData({ queryKey: ["businesses"] }, (oldData) => {
        if (
          !oldData ||
          !oldData.businesses ||
          !Array.isArray(oldData.businesses)
        ) {
          return oldData;
        }

        return {
          ...oldData,
          businesses: oldData.businesses.map((business) =>
            business.id === businessId ? { ...business, enabled } : business,
          ),
        };
      });

      // Invalidate and refetch businesses queries to ensure consistency
      queryClient.invalidateQueries({ queryKey: ["businesses"] });

      toast.success(
        `Business ${enabled ? "activated" : "deactivated"} successfully`,
      );
    },
    onError: (error) => {
      console.error("Error toggling business:", error);
      toast.error("Failed to update business status");
    },
  });
};

export default useBusinessToggle;
